import { clearState, setLoading } from 'src/contexts/utils';
import { IMaintenancePackageInitialContext } from '../types';
import { DEFAULT_MAINTENANCE_PACKAGE_STATE } from './defaultState';
import { IMaintenancePackage } from 'src/interfaces/maintenancePackage';

export const DEFAULT_MAINTENANCE_PACKAGE_CONTEXT: IMaintenancePackageInitialContext =
    {
        ...DEFAULT_MAINTENANCE_PACKAGE_STATE,
        searchMaintenancePackagesByFilters: () => Promise.resolve(undefined),
        getMaintenancePackageById: () => Promise.resolve(undefined),
        updateMaintenancePackageById: () => Promise.resolve(undefined),
        createMaintenancePackage: (): Promise<
            Partial<IMaintenancePackage> | undefined
        > => Promise.resolve(undefined),
        deleteMaintenancePackageById: () => Promise.resolve(undefined),
        bulkDeleteMaintenancePackages: () => Promise.resolve(undefined),
        clearState,
        setLoading,
    };
